import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store  from './store'

//** external libraries
import _ from 'lodash'

Vue.config.productionTip = false

//** miscellaneous setup
import * as echarts from 'echarts'
import shine   from '@/components/plugins/echarts-theme-macaroons'
// import Vuetify from 'vuetify/lib'

//** global functions/variables
window.echarts = echarts
echarts.registerTheme('shine', shine)

window.$ = x => {
  const o = [...document.querySelectorAll(x)]
  return _.size(o) === 1 ? o[0] : o
}
//** mount Vue
new Vue({ vuetify, router, store, render: h => h(App) }).$mount('#app')
